// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "flight-tdZM5";
var _5 = "flightSegments-vm6eg";
var _6 = "segmentInfo-2_EkN";
var _7 = "segmentInfo__flightNumber-36RHk";
var _8 = "segmentInfo__operating-VNkWo";
var _9 = "segmentInfo__segment-2qxL-";
var _a = "segment__planeContainer-1vdiG";
var _b = "segment__routeInfo-1KB3L";
var _c = "totalDuration-3nUlU";
var _d = "totalDuration__decorator-3B2P6";
var _e = "routeArrow__container-32shc";
var _f = "routeArrow__flightNumber-cErwg";
var _10 = "routeArrow__stop-2GvMQ";
var _11 = "routeArrow__route-1mwHp";
var _12 = "routeArrow__circle-3o5sG";
var _13 = "routeArrow__timeInRoute-3vZlS";
var _14 = "point__dateContainer-ped4k";
var _15 = "point__time-xhHMq";
var _16 = "point__airport-21ZYL";
var _17 = "point__airport_arrival-3cE8m";
var _18 = "routeInfo__totalDuration-xskxh";
var _19 = "stop-1N3g5";
var _1a = "planeInfo-1QJp3";
var _1b = "aircrafts-36l5Z";
var _1c = "amenities-21Mmo";
var _1d = "mobileFlight__flight-1Sp8i";
var _1e = "mobileFlight__readonly-1teHd";
var _1f = "mobileFlight__expanded-1cdOi";
var _20 = "mobileFlight__segments-2Tqu5";
var _21 = "companyName-1Wp0j";
var _22 = "routeInfo__route_info-1sOvx";
var _23 = "weekDays-3UcPz";
var _24 = "routeInfo__row-pf1mr";
var _25 = "point__schedule-2t9Mg";
var _26 = "point_date-3ofjz";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "flight", _5 as "flightSegments", _6 as "segmentInfo", _7 as "segmentInfo__flightNumber", _8 as "segmentInfo__operating", _9 as "segmentInfo__segment", _a as "segment__planeContainer", _b as "segment__routeInfo", _c as "totalDuration", _d as "totalDuration__decorator", _e as "routeArrow__container", _f as "routeArrow__flightNumber", _10 as "routeArrow__stop", _11 as "routeArrow__route", _12 as "routeArrow__circle", _13 as "routeArrow__timeInRoute", _14 as "point__dateContainer", _15 as "point__time", _16 as "point__airport", _17 as "point__airport_arrival", _18 as "routeInfo__totalDuration", _19 as "stop", _1a as "planeInfo", _1b as "aircrafts", _1c as "amenities", _1d as "mobileFlight__flight", _1e as "mobileFlight__readonly", _1f as "mobileFlight__expanded", _20 as "mobileFlight__segments", _21 as "companyName", _22 as "routeInfo__route_info", _23 as "weekDays", _24 as "routeInfo__row", _25 as "point__schedule", _26 as "point_date" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "flight": _4, "flightSegments": _5, "segmentInfo": _6, "segmentInfo__flightNumber": _7, "segmentInfo__operating": _8, "segmentInfo__segment": _9, "segment__planeContainer": _a, "segment__routeInfo": _b, "totalDuration": _c, "totalDuration__decorator": _d, "routeArrow__container": _e, "routeArrow__flightNumber": _f, "routeArrow__stop": _10, "routeArrow__route": _11, "routeArrow__circle": _12, "routeArrow__timeInRoute": _13, "point__dateContainer": _14, "point__time": _15, "point__airport": _16, "point__airport_arrival": _17, "routeInfo__totalDuration": _18, "stop": _19, "planeInfo": _1a, "aircrafts": _1b, "amenities": _1c, "mobileFlight__flight": _1d, "mobileFlight__readonly": _1e, "mobileFlight__expanded": _1f, "mobileFlight__segments": _20, "companyName": _21, "routeInfo__route_info": _22, "weekDays": _23, "routeInfo__row": _24, "point__schedule": _25, "point_date": _26 }
